import { useEffect, useState } from 'react';
import { NavLink, withRouter } from 'react-router-dom';

import AlertService from '../../../../components/SweetAlert';
import ToastUtil from '../../../../components/ToastNotification/ToastUtil';
import { config } from '../../../../config';
import { DELETE, GET, newFetch, PUT } from '../../../../helpers/fetch';
import LayoutContext from '../../../../store/Layout/contexts';

const { SERVER_URL } = config;

const EditLeave = ({
  history,
  match: {
    params: { claim_id },
  },
}) => {
  const accessType = localStorage.getItem('type');
  const [selectedAssociate, setSelectedAssociate] = useState(0);
  const [type, setType] = useState(0);
  const [dateReceipt, setDateReceipt] = useState('');
  const [amount, setAmount] = useState('');
  const [remarks, setRemarks] = useState('');
  const [statusOptions, setStatusOptions] = useState([]);
  const [client, setClient] = useState('');
  const [status, setStatus] = useState(0);
  const [claim, setClaim] = useState('');
  const [adminRemarks, setAdminRemarks] = useState('');
  const [file, setFile] = useState([]);
  const [origAdminRemarks, setOrigAdminRemarks] = useState([]);
  const [origStatus, setOrigStatus] = useState([]);
  const [filePath, setFilePath] = useState([]);

  const fetchStatusOptions = async () => {
    let api_path = `/fields/claim_status`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setStatusOptions(response.data);
    }
  };

  const fetchClaim = async () => {
    let api_path = `/claims/${claim_id}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let responseData = response.data;
      setClaim(responseData);
      setStatus(responseData.status);
      setSelectedAssociate(
        responseData.associate.first_name +
          ' ' +
          responseData.associate.last_name
      );
      setType(responseData.claim_types.name);
      setAmount(responseData.amount);
      setDateReceipt(responseData.date_of_receipt);
      setRemarks(responseData.remarks);
      setAdminRemarks(responseData.mp_remarks);
      setFile(responseData.orig_file);
      setFilePath(responseData.new_file);
      setClient(responseData.associate.sites[0].client.name);
      setOrigAdminRemarks(responseData.mp_remarks);
      setOrigStatus(responseData.status);
    }
  };

  const validateForm = () => {
    if (parseInt(status) === 0 || !status) {
      ToastUtil.error('Please select a Status!');
      return false;
    }

    if (!adminRemarks) {
      ToastUtil.error('Please input Admin Remarks!');
      return false;
    }

    return true;
  };

  const HandleSubmitUpdate = async (e) => {
    e.preventDefault();

    if (
      validateForm() &&
      (await AlertService.confirm(
        '',
        `Are you sure you want to update this Claim?`
      ))
    ) {
      let api_path = `/claims/${claim_id}`;
      let response = await newFetch(PUT, api_path, {
        status,
        mp_remarks: adminRemarks,
      });

      ToastUtil.success(response.message);

      if (response.success) {
        history.push(`/claims`);
      }
    }
  };

  const handleDiscard = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to discard all changes?'
      )
    ) {
      setStatus(origStatus || 0);
      setAdminRemarks(origAdminRemarks || '');
    }
  };

  const handleDeleteClaim = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to delete this Claim?'
      )
    ) {
      let api_path = `/claims/${claim_id}`;
      let response = await newFetch(DELETE, api_path);

      ToastUtil.success(response.message);

      response.success && history.push(`/claims`);
    }
  };

  useEffect(() => {
    fetchClaim();
    fetchStatusOptions();
  }, []);

  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => {
        return (
          <div style={{ paddingTop: '3rem' }}>
            <div
              className="d-flex flex-column"
              style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
            >
              <NavLink
                to={`/claims`}
                className="text-decoration-none"
                style={{ color: 'inherit' }}
              >
                <div style={{ color: '#A6478E' }}>
                  <i className="fas fa-chevron-left pe-2"></i>Back to Claims
                </div>
              </NavLink>
              <div className="pt-4">
                <h5>Edit Claim</h5>
              </div>
            </div>
            <form className="form" onSubmit={(e) => HandleSubmitUpdate(e)}>
              <div
                style={{
                  marginTop: '1rem',
                  paddingLeft: '3rem',
                  paddingRight: '3rem',
                  paddingBottom: '6rem',
                }}
              >
                <div className="d-flex border rounded adjust-shadow">
                  <div
                    className="flex-grow-1 bg-white col-md-7"
                    style={{ padding: '2.25rem' }}
                  >
                    <div
                      className="row col-md-12"
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <strong>Client</strong>
                      <p className="adjust-fs text-muted">{client}</p>
                    </div>
                    <div
                      className="row col-md-12"
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <strong>Employee Name</strong>
                      <p className="adjust-fs text-muted">
                        {selectedAssociate}
                      </p>
                    </div>
                    <div
                      className="row col-md-12"
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <strong>Type</strong>
                      <p className="adjust-fs text-muted">{type}</p>
                    </div>
                    <div
                      className="row col-md-12"
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <strong>Date of Receipt</strong>
                      <p className="adjust-fs text-muted">{dateReceipt}</p>
                    </div>
                    <div
                      className="row col-md-12"
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <strong>Amount</strong>
                      <p className="adjust-fs text-muted">{amount}</p>
                    </div>
                    <div
                      className="row col-md-12"
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <strong>File</strong>
                      <p className="adjust-fs text-muted">
                        {file}&nbsp;&nbsp;
                        <a
                          href={`${SERVER_URL}/storage/claims/${filePath}`}
                          target="_blank"
                        >
                          <i className="fa fa-file-text font-size-18"></i>
                        </a>
                      </p>
                    </div>
                    <div
                      className="row col-md-12"
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <strong>Employee Remarks</strong>
                      <p className="adjust-fs text-muted">{remarks}</p>
                    </div>
                    <div className="row pb-3 col-md-8">
                      <strong>Status</strong>
                      <p>{status || ''}</p>
                    </div>
                    <div className="row pb-3 col-md-12">
                      <strong>Approver/Admin Remarks</strong>
                      <p>{adminRemarks || ''}</p>
                    </div>
                  </div>
                  <div
                    className="flex-grow-1 bg-white col-md-5"
                    style={{ paddingTop: '2.25rem' }}
                  ></div>
                </div>
              </div>

              <div
                style={{
                  position: 'fixed',
                  bottom: 0,
                  width: activeSidebar ? 'calc(100vw - 310px)' : '100vw',
                  height: '4.5rem',
                  paddingRight: '3rem',
                }}
                className="border-top bg-white d-flex align-items-center justify-content-end"
              >
                {/* <button
                  type="button"
                  className="btn btn-outline-brand adjust-fs adjust-shadow"
                  style={{ width: '12rem' }}
                  onClick={handleDiscard}
                >
                  Discard
                </button>
                <button
                  type="submit"
                  className="btn btn-brand ms-3 adjust-fs adjust-shadow"
                  style={{ width: '12rem' }}
                >
                  Save changes
                </button> */}
              </div>
            </form>
          </div>
        );
      }}
    </LayoutContext.Consumer>
  );
};

export default withRouter(EditLeave);
